import * as Types from './types';

import gql from 'graphql-tag';
export type LegacyLiveGamesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where: Types.Game_Filter;
  orderBy?: Types.InputMaybe<Types.Game_OrderBy>;
  orderDirection?: Types.InputMaybe<Types.OrderDirection>;
}>;


export type LegacyLiveGamesQuery = { __typename?: 'Query', games: Array<{ __typename?: 'Game', id: string, gameId: string, slug?: string | null, title?: string | null, startsAt: string, status: Types.GameStatus, sport: { __typename?: 'Sport', sportId: string, slug: string, name: string, sporthub: { __typename?: 'SportHub', id: string, slug: string } }, league: { __typename?: 'League', id: string, slug: string, name: string, country: { __typename?: 'Country', id: string, slug: string, name: string } }, participants: Array<{ __typename?: 'Participant', image?: string | null, name: string }> }> };


export const LegacyLiveGamesDocument = gql`
    query LegacyLiveGames($first: Int, $skip: Int, $where: Game_filter!, $orderBy: Game_orderBy, $orderDirection: OrderDirection) {
  games(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    id
    gameId
    slug
    title
    startsAt
    status
    sport {
      sportId
      slug
      name
      sporthub {
        id
        slug
      }
    }
    league {
      id
      slug
      name
      country {
        id
        slug
        name
      }
    }
    participants {
      image
      name
    }
  }
}
    `;